import { HttpClient } from '@angular/common/http';
import { Component, Injector, OnInit } from '@angular/core';
import { ActivatedRoute, Event, NavigationEnd, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { MessageService } from 'src/app/@shared/message/message.service';
import { CommonService } from 'src/app/@shared/services/common.service';
import { SharedService } from 'src/app/@shared/services/shared.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';
import { SportDetailComponent } from '../sport-detail.component';
import { MMarketRuleComponent } from 'src/app/@shared/components/market-rule/m-market-rule/m-market-rule.component';
import { DMarketRuleComponent } from 'src/app/@shared/components/market-rule/d-market-rule/d-market-rule.component';

@Component({
  selector: 'app-m-sport-detail',
  templateUrl: './m-sport-detail.component.html',
  styleUrls: ['./m-sport-detail.component.css']
})
export class MSportDetailComponent extends SportDetailComponent implements OnInit {
  public isCollapsed: boolean = true;

  constructor(public service: WebserviceService,
    protected actRoute: ActivatedRoute,
    public _common: CommonService,
    public _message: MessageService,
    public router: Router,
    public _shared: SharedService,
    protected injector: Injector,
    protected modalService: BsModalService,
    protected http: HttpClient
  ) {
    super(service, actRoute, _common, _message, router, _shared, injector, modalService, http,);
    this.constructorCallData();
  }

  ngOnInit(): void {
    this.rout();
    this.getData();
    if (this.webSocketUrl != '')
      this.scoreData();
  }

  rout() {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        if (this.id != this.actRoute.snapshot.paramMap.get('id') || (this.mId != null && this.mId != this.actRoute.snapshot.paramMap.get('mId'))) {
          this.id = this.actRoute.snapshot.paramMap.get('id');
          this.mId = this.actRoute.snapshot.paramMap.get('mId');
          this.marketsReq = [];
          this.oodsList = [];
          this.data = undefined;
          this.getData();
        }
      }
    })
  }

  getKeyName(e: any) {
    return (e.includes('other')) ? e.substring(1) : e
  }

  bsModalRef!: BsModalRef;
  openModalWithComponent(key: any) {
    const initialState: any = { key: key };
    this.bsModalRef = this.modalService.show((this.env.isMobile)?MMarketRuleComponent:DMarketRuleComponent, {
      initialState,
      class: `${this.env.isMobile ? 'modal-xl' : 'modal-full'}`
    });
    this.bsModalRef.content.closeBtnName = 'Close';
  }

  getTvData() {
    if (this.isLoginWithDemo()) {
      this._message.errmessage('Sorry for inconvenience Use real ID to watch streaming..');
    } else {
      this.isCollapsed = !this.isCollapsed;
      if (this.isCollapsed) {
        this.tvSteam = '';
      } else {
        this.tvData('mobile');
      }
    }
  }

}
